import { FC } from "react";
import ChatBot from "../../Components/ChatBot";
import styles from "./style.module.scss";

interface UserInfo {
  name: string;
  role: string;
}
interface StateProps {
  userInfo?: UserInfo;
  show?: boolean;
}
const Footer: FC<StateProps> = ({ show = true }) => {

  return (
    <>
      {show &&
        <div className={styles.floatElement}>
          <ChatBot />
        </div>
      }
      <div className={styles.footer}></div>
    </>
  );
};

export default Footer;
